import React, { useState } from "react";
import { TableTitle } from "../../Material/single/MaterialList/Styled";
import { StyledTableCell } from "../../../shared/components/CustomTable/Styled";
import { ItemList as MaterialImportList, ItemListItem as MaterialImportListItem, ItemListItemQuantity as MaterialImportListItemQuantity } from "../../../shared/styled/ListItemStyles";
import { IconButton, ListItem, ListItemText, TableRow } from "@mui/material";
import { MaterialImportInfo } from "../../../data/entities";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Template from "../../../templates/PMS - Phiếu nhập kho vật tư.docx";
import { generateDocument, generateDocumentBlob } from "../../../utils/exportUtils";
import { buildDocxData } from "../../../utils/docxBuilder";
import { materialImportHistoryDownloadDescriptor } from "../../../utils/docxMappings";
import ListView from "../../../shared/components/ListView";
import {  MaterialsImportFilterType } from "../../../configs/filterTypes";
import {  MaterialsImportSortTypes } from "../../../configs/sortTypes";
import DocxPreviewModal from "../../../shared/components/DocxPreviewModal";
import DownloadIcon from "@mui/icons-material/Download";
import { StyledButton } from "../../../shared/styled/TitleBar";
import MaterialHistoryDeepLinkPreview from "../MaterialHistoryDeepLinkPreview";

const MaterialImportHistoryTableColumns = [
    {
        text: 'Mã phiếu',
        icon: <></>
    },
    {
        text: 'Nhà cung cấp',
        icon: <></>
    },
    {
        text: 'Người giao hàng',
        icon: <></>
    },
    {
        text: 'Phương thức nhập',
        icon: <></>
    },
    {
        text: 'Ghi chú',
        icon: <></>
    },
    {
        text: 'Vật tư nhập',
        icon: <></>
    },
    {
        text: 'Ngày tạo',
        icon: <></>
    },
    {
        text: 'Ngày nhập kho',
        icon: <></>
    },
    {
        text: 'Xem trước',
        icon: <></>
    },
];


interface MaterialImportHistoryRowProps {
    item: MaterialImportInfo;
    extraRowProps: any;
}

const MaterialImportHistoryRow = ({ item }: MaterialImportHistoryRowProps) => {
    const itemDate = new Date(item.import_date);
    const exportData = buildDocxData(item, materialImportHistoryDownloadDescriptor);

    const onClickDownload = () => {
        generateDocument(exportData, Template, `phieu_nhap_kho_${itemDate.toLocaleDateString('en-GB')}`);
    }

    const [previewBlob, setPreviewBlob] = useState<Blob | null>(null);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    const onClickPreview = () => {
        generateDocumentBlob(exportData, Template).then((blob) => {
            console.debug("Generated DOCX blob for preview", { size: blob.size, type: blob.type });
            setPreviewBlob(blob);
            setIsPreviewOpen(true);
        });
    }


    return (
        <>
            <TableRow>
            <StyledTableCell>{item.import_code}</StyledTableCell>
            <StyledTableCell>{item.provider_name}</StyledTableCell>
            <StyledTableCell>{item.deliverer}</StyledTableCell>
            <StyledTableCell>{item.input_method}</StyledTableCell>
            <StyledTableCell>{item.note}</StyledTableCell>
            <StyledTableCell>
                <MaterialImportList>
                    {item.materials.map((material, index) => (
                        <ListItem 
                            key={material.material.id || index}
                            dense
                            disableGutters
                            style={{ padding: '2px 0' }}
                        >
                            <ListItemText
                                primary={
                                    <MaterialImportListItem>        
                                        <span>{material.material.name}</span>
                                        <MaterialImportListItemQuantity>
                                            x{material.quantity}
                                        </MaterialImportListItemQuantity>
                                    </MaterialImportListItem>
                                }
                            />
                        </ListItem>
                    ))}
                </MaterialImportList>
            </StyledTableCell>
            <StyledTableCell>{new Date(item.created_at).toLocaleDateString('en-GB')}</StyledTableCell>
            <StyledTableCell>{new Date(item.import_date).toLocaleDateString('en-GB')}</StyledTableCell>
            <StyledTableCell>
                <IconButton onClick={onClickPreview} title="Xem trước phiếu">
                    <VisibilityIcon />
                </IconButton>
            </StyledTableCell>
        </TableRow>
        
        <DocxPreviewModal
            open={isPreviewOpen}
            onClose={() => setIsPreviewOpen(false)}
            blob={previewBlob}
            title="Xem trước phiếu nhập kho"
            debug={false}
            actions={
                <StyledButton
                    variant="outlined"
                    onClick={onClickDownload}
                >
                    <DownloadIcon style={{ marginRight: '8px' }} />
                    Tải phiếu
                </StyledButton>
            }
        />
        </>
    );
};

const MaterialImportHistory = () => {
    return (
        <>
        <ListView
            url="/materials/imports/"
            filterTypes={MaterialsImportFilterType}
            sortTypes={MaterialsImportSortTypes}
            rowElement={MaterialImportHistoryRow}
            tableColumns={MaterialImportHistoryTableColumns}
            textString={"Tìm kiếm theo tên nhà cung cấp, mã phiếu nhập kho, tên vật tư"}
        />
        <MaterialHistoryDeepLinkPreview kind="import" />
        </>
    );
};

export default MaterialImportHistory;
